$(function () {
  $(window).on("scroll", function () {
    var $CTA = $(".js-productStickyCTA");
    var scrollValue = $(window).scrollTop();
    var $showPositionDom = $(".js-stickyProductShow");
    var $hidePositionDom = $(".js-stickyProductHide");
    var showClass = "is-sticky";

    if ($CTA.length && $showPositionDom.length && $hidePositionDom.length) {
      var $showPosition = $showPositionDom.offset().top;
      var $hidePosition = $hidePositionDom.offset().top - 1000;

      if (scrollValue > $showPosition && scrollValue < $hidePosition) {
        $CTA.addClass(showClass);
      } else {
        $CTA.removeClass(showClass);
      }
    }
  });
})